import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

export const Content = styled.div`
  flex: 1;
  padding: 32px 40px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

export const Header = styled.div`
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackButton = styled.button`
  background: white;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #202124;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  span {
    font-size: 18px;
  }

  &:hover {
    background: #f8f9fa;
    border-color: #dadce0;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #202124;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  padding: 60px 40px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f3f3f3 0%, #ececec 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  span {
    font-size: 40px;
    color: #9aa0a6;
  }
`;

export const EmptyTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 12px;
`;

export const EmptyDescription = styled.p`
  margin: 0;
  font-size: 16px;
  color: #5f6368;
  max-width: 400px;
`;
